import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=027c25c6"
import script from "./customButton.ts?vue&type=script&lang=js&external"
export * from "./customButton.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports